import { render, staticRenderFns } from "./goodsPaymentInfo.vue?vue&type=template&id=3b5d306c&scoped=true&"
import script from "./goodsPaymentInfo.vue?vue&type=script&lang=js&"
export * from "./goodsPaymentInfo.vue?vue&type=script&lang=js&"
import style0 from "./goodsPaymentInfo.vue?vue&type=style&index=0&id=3b5d306c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5d306c",
  null
  
)

export default component.exports